<template>
  <div class="comp-notes">
    <h1 class="headline">NOTES</h1>

    <div class="toolbar">
      <div class="btns">
        <button type="button" class="btn btn-outline-black w180" @click="showModalAdd = true">+ New Note</button>
      </div>

      <div class="filters">
        <div class="input-search">
          <input type="text" name="s" class="form-control" placeholder="SEARCH NOTES..." v-model="keyword" @change="doPaging(1)">
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-sm table-hover">
        <thead>
          <tr>
            <th width="20%"><a href="javascript:;" data-sort-field="client_name" @click="doSort($event)" class="sort asc">CLIENT</a></th>
            <th><a href="javascript:;" data-sort-field="note_title" @click="doSort($event)" class="sort">TITLE</a></th>
            <th width="20%"><a href="javascript:;" data-sort-field="note_creator" @click="doSort($event)" class="sort">CREATOR</a></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(note, index) in notes" :key="index"  @click="gotoNote(note.id)" style="cursor: pointer;">
            <td>{{ note.client?note.client.name:'N/A' }}</td>
            <td>{{ note.title }}</td>
            <td>{{ note.creator ? note.creator.full_name : 'N/A' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="hasFilters && notes.length == 0" class="alert alert-warning">No notes found</div>
    <div class="d-flex justify-content-between">
      <pagination :total-pages="totalPages" :current-page="currentPage" @goto-page="doPaging"></pagination>
    </div>
    <modal-add-note v-model="showModalAdd" @note-created="onNoteAdded"></modal-add-note>
  </div>
</template>

<script>
  import jquery from "jquery"
  import ServiceNote from '@/services/note'
  import ModalAddNote from './ModalAddNote'

  export default {
    components: {
      ModalAddNote,
    },
    data () {
      return {
        showModalAdd: false,
        keyword: '',
        activeIndex: -1,
        totalItems: 0,
        currentPage: 1,
        totalPages: 0,
        notes: [],
        bulkAction: '',
        sort: 'client_name',
        order: 'asc'
      }
    },
    computed: {
      activeNote () {
        let self = this;
        return self.notes[self.activeIndex] ? self.notes[self.activeIndex] : null;
      },
      hasFilters () {
        let self = this;
        return self.keyword != '';
      }
    },
    mounted () {
      this.init();
    },
    methods: {
      init () {
        let self = this;
        self.getNotes();
      },
      onNoteAdded ( note ) {
        let self = this;
        self.notes.unshift( note );
      },
      doPaging ( page ) {
        let self = this;
        self.currentPage = page;
        self.getNotes();
      },
      _getParams () {
        let self = this,
          params = {
            page: self.currentPage,
          };

        if ( self.keyword !== '' ) {
          params.kw = self.keyword;
        }
        params['sort'] = self.sort;
        params['order'] = self.order;
        return params;
      },
      getNotes () {
        let self = this, params = self._getParams();

        ServiceNote.getNotes(params, resp => {
          self.notes = resp.data;
          self.totalPages = resp.last_page;
          self.totalItems = resp.total;
        });
      },
      gotoNote(noteId) {
        this.$router.push({name: 'note', params: {noteId: noteId}});
      },
      doSort (event) {
        let self = this, params = self._getParams(), header = event.target;

        // Go through all header and reset the sort class
        jquery('.sort').not(header).attr('class', 'sort');

        if (typeof header.dataset.sortField != 'undefined') {
          params['sort'] = header.dataset.sortField;
          if (header.className.indexOf('asc') == -1) {
            /* Not sort or in desc */
            params['order'] = 'asc';
            header.className = header.className.replace(' desc', '') + ' asc';
          } else if (header.className.indexOf('desc') == -1) {
            params['order'] = 'desc';
            header.className = header.className.replace(' asc', '') + ' desc';
          }
          self.sort = params['sort'];
          self.order = params['order'];
          ServiceNote.getNotes(params, resp => {
            self.notes = resp.data;
            self.totalPages = resp.last_page;
            self.totalItems = resp.total;
          });
        }
      }
    }
  }
</script>
